<template>
  <base-container :fluid="true" class="video-catalog">
    <base-container>
      <the-header>
        <template v-slot:leftAligned>
          <h1 class="lvl1-heading">
            Catalogue
            <span>de Vidéos</span>
          </h1>
          <span>
            Profitez de notre large choix de vidéos à diffuser dans votre
            pharmacie
          </span>
        </template>
        <template v-slot:rightAligned>
          <TheSearchInput @change="handleSearchChange" />
        </template>
      </the-header>
    </base-container>
    <TheFilters
      ref="filters"
      @marquesChange="handleMarquesChange"
      @themesChange="handleThemesChange"
      @supportsChange="handleSupportsChange"
      @freeChange="handleFreeChange"
    />
    <template v-if="sliders && !searching">
      <TheTrendingVideos
        v-for="slider in sliders"
        :key="slider.id"
        :slider="slider"
      />
    </template>
    <base-container
      style="margin-top: 80px;"
      ref="videosGrid"
      class="video-catalog__videos"
    >
      <h2 class="lvl2-heading">
        Catalogue de produits
      </h2>
      <template v-if="videos.length">
        <base-grid class="videos-grid">
          <VideoCard
            v-for="video in videos"
            :key="video.id"
            :video="video"
            thumbnailSize="small"
          />
        </base-grid>
        <base-container :fluid="true" :centered="true">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalVideos"
            :current-page.sync="localFilters.page"
            :page-size="videosPerPage"
          ></el-pagination>
        </base-container>
      </template>
      <span v-else-if="!$data._loader"
        >Aucune vidéo ne correspond aux critéres de recherche.</span
      >
    </base-container>
    <!-- alert validation banner -->
    <alert-banner @close="handleBannerClose" v-if="validationBanner.open">
      <span class="banner-message" v-html="validationBanner.message"></span>
      <base-link :isRouterLink="true" :path="{ name: 'planning' }"
        >Accéder à mes listes de diffusion</base-link
      >
    </alert-banner>
  </base-container>
</template>

<script>
import TheSearchInput from "./components/TheSearchInput.vue"
import TheFilters from "./components/TheFilters.vue"
import TheTrendingVideos from "./components/TheTrendingVideos.vue"
import TheHeader from "@/components/TheHeader.vue"
import VideoCard from "@/components/VideoCard.vue"
import { Pagination } from "element-ui"
import { getVideos as fetchVideos } from "@/api/videos"
import { getSliders as fetchSliders } from "@/api/sliders"
import { loaderMixin } from "@/mixins"
import { mapGetters } from "vuex"

export default {
  components: {
    TheSearchInput,
    TheFilters,
    TheTrendingVideos,
    VideoCard,
    ElPagination: Pagination,
    TheHeader,
    AlertBanner: () => import("@/components/Banner.vue")
  },
  data() {
    return {
      localFilters: {
        brands: [],
        themes: [],
        type_supports: [],
        keyword: "",
        free: false,
        page: 1
      },
      sliders: null,
      trendingVideos: [],
      videos: [],
      videosPerPage: 0,
      totalVideos: 0,
      onFilter: false,
      searching: false
    }
  },
  computed: {
    ...mapGetters(["validationBanner", "scroller"]),
    // we set filters as a computed property
    // because we need to trigger watch
    // handler on 'page' prop change
    filters() {
      const filters = Object.assign({}, this.localFilters)
      return filters
    }
  },
  watch: {
    filters: {
      handler() {
        // we set an empty route query
        // to trigger the $route watch handler
        // this will allow us to set onFilter
        // to false again and to scroll to the
        // top of the page if a filter has changed

        this.onFilter = true
        this.scroller.scroll({ x: 0, y: this.topScrollTarget }, 800)
        this.videos = []
        this.getVideos()
      },
      deep: true
    }
  },
  mixins: [loaderMixin],
  methods: {
    handleMarquesChange(marques) {
      this.localFilters.brands = marques
      this.setSearching()
    },
    handleThemesChange(themes) {
      this.localFilters.themes = themes
      this.setSearching()
    },
    handleSupportsChange(type_supports) {
      this.localFilters.type_supports = type_supports
      this.setSearching()
    },
    handleSearchChange(keyword) {
      this.localFilters.keyword = keyword
      this.searching = keyword.length > 0
    },
    handleFreeChange(value) {
      this.localFilters.free = value
    },
    setSearching() {
      const { brands, type_supports, themes } = this.localFilters
      this.searching = brands.length || type_supports.length || themes.length
    },
    // Get filtered videos
    async getVideos() {
      this.openLoader(this.$refs.videosGrid.$el)
      try {
        let res = await fetchVideos(this.filters)

        this.videos = res.data
        this.currentPage = res.current_page
        this.videosPerPage = res.per_page
        this.totalVideos = res.total

        this.closeLoader()
      } catch (error) {
        this.closeLoader()
      }
    },
    // Get sliders
    async getSliders() {
      try {
        let res = await fetchSliders()
        this.sliders = res.data

        this.closeLoader()
      } catch (error) {
        console.error(error)
        this.closeLoader()
      }
    },
    handleBannerClose() {
      this.$store.dispatch("closeValidationBanner")
    }
  },
  mounted() {
    this.getVideos()
    this.getSliders()
    fetchVideos({ trending: 1 }).then(res => {
      // since the endpoint isn't entirely working
      // we do another filter to only get trending videos
      this.trendingVideos = res.data.filter(v => v.trending)
    })
    this.topScrollTarget = this.$refs.filters.$el.offsetTop
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.video-catalog {
  padding-bottom: 40px;
  .banner-message {
    font-family: $font-family-muli;
    font-weight: 800;
    margin-right: 30px;
    & > span {
      color: $color-secondary;
      color: var(--color-secondary, $color-secondary);
    }
  }
}

.videos-grid {
  // height: 156px;
  .video-card {
    height: 100%;
  }
}

/* Fix video player height */
.plyr__video-wrapper > video {
  height: 156px;
}
</style>
